import React from "react";

const CodigoGeografico = (props) => {
    const { data, domicilio, novedad, guardarCampo } = props;
    const me = this;

    let codigoGeografico = data.empresaDatos.DomicilioCodigoGeografico;
    let radioCodigoGeo = null;
    let codigos;

    const desactivarInput = (codigoGeografico != "0");

    if (data.getCodigoGeograficoVisa) {
        const codigoElements = data.getCodigoGeograficoVisa.filter(c => c.CodigoPostal == domicilio.CodigoPostal);

        codigos = JSON.parse(JSON.stringify(codigoElements));
        codigos.push({ Id: 0, CodigoGeografico: "0" });

        radioCodigoGeo = codigos.map((codigo, index) => {
            const estaSeleccionado = (codigo.CodigoGeografico == codigoGeografico);

            if (codigo.CodigoGeografico == "0") {
                return (
                    <div className="col-xs-8" key={"div-codigo-geo-" + index}>
                        <div className="col-xs-6">
                            <div className="container-radio radio-margin">
                                <input value="0" type="radio" name="codigo-geografico"
                                    id={"codigo-geografico-" + index} checked={estaSeleccionado}
                                    onChange={() => { guardarCampo("0", "DomicilioCodigoGeografico") }} />

                                <label className="lbl-radio label-secondary" htmlFor={"codigo-geografico-" + index}>Otro</label>
                            </div>
                        </div>
                        <div className="col-xs-6">
                            <input value={data.empresaDatos.DomicilioCodigoGeograficoInput} type="text"
                                className="form-control default-input" maxLength="5" disabled={(desactivarInput)}
                                onChange={(event) => { guardarCampo(event.target.value, "DomicilioCodigoGeograficoInput") }} />
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className="col-xs-2" key={"div-codigo-geo-" + index}>
                        <div className="container-radio radio-margin">
                            <input value={codigo.CodigoGeografico} type="radio" name="codigo-geografico"
                                id={"codigo-geografico-" + index} checked={estaSeleccionado}
                                onChange={(event) => { guardarCampo(event.target.value, "DomicilioCodigoGeografico") }} />

                            <label className="lbl-radio label-secondary" htmlFor={"codigo-geografico-" + index}>{codigo.CodigoGeografico}</label>
                        </div>
                    </div>
                );
            }
        });
    }

    return (
        <div>
            <div className="row">
                <div className="col-xs-12">
                    <h5>{"Código geográfico para " + domicilio.Localidad}</h5>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    {radioCodigoGeo}
                </div>
                <div className="col-xs-12">
                    {props.error &&
                        <label className="error">Debe completar el código geografico</label>}
                </div>
            </div>
        </div>
    );
}

export default CodigoGeografico;